/* eslint-disable key-spacing */
export const add = {
  project_type_id: {
    required: {
      rule: true, message: 'Vous devez choisir un parcours'
    }
  },
  participant: {
    required: {
      rule: true, message: 'Vous devez choisir un participant'
    }
  },
  contact_date_fl: {
    validateDate: {
      rule: true, message: 'La date n\'a pas un format valide'
    }
  },
  first_meeting_date: {
    validateDate: {
      rule: true, message: 'La date n\'a pas un format valide'
    }
  },
  meeting_date_incubator_info: {
    validateDate: {
      rule: true, message: 'La date n\'a pas un format valide'
    }
  },
  incubator_application_deposit_date: {
    validateDate: {
      rule: true, message: 'La date n\'a pas un format valide'
    }
  },
  exit_date: {
    validateDate: {
      rule: true, message: 'La date n\'a pas un format valide'
    }
  }
}

export const edit = {
  project_type_id: {
    required: {
      rule: true, message: 'Vous devez choisir un parcours'
    }
  },
  participant: {
    required: {
      rule: true, message: 'Vous devez choisir un participant'
    }
  },
  contact_date_fl: {
    validateDate: {
      rule: true, message: 'La date n\'a pas un format valide'
    }
  },
  first_meeting_date: {
    validateDate: {
      rule: true, message: 'La date n\'a pas un format valide'
    }
  },
  meeting_date_incubator_info: {
    validateDate: {
      rule: true, message: 'La date n\'a pas un format valide'
    }
  },
  incubator_application_deposit_date: {
    validateDate: {
      rule: true, message: 'La date n\'a pas un format valide'
    }
  },
  exit_date: {
    validateDate: {
      rule: true, message: 'La date n\'a pas un format valide'
    }
  }
}



// WEBPACK FOOTER //
// ./src/validations/project.js